export default __webpack_public_path__ + "static/media/plusIconRed.71470589.svg";